import {FloorChoice} from "../../../real_estate/types/FloorChoice";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const floorChoices: ISearchFilterSlot<"floor_choices", string[]> = {
    id: "floor_choices",
    label: "Piętro",
    filters: [
        {
            id: "floor_choices",
            type: SearchFilterTypes.MULTI_CHECKBOX,
            filterOptions: [
                {
                    id: `floor_choices_${FloorChoice.GROUND.toString()}`,
                    value: FloorChoice.GROUND.toString(),
                    label: "Parter"
                },
                {
                    id: `floor_choices_${FloorChoice.GROUND_WITH_GARDEN.toString()}`,
                    value: FloorChoice.GROUND_WITH_GARDEN.toString(),
                    label: "Parter z ogródkiem"
                },
                {
                    id: `floor_choices_${FloorChoice.LOW_LEVELS.toString()}`,
                    value: FloorChoice.LOW_LEVELS.toString(),
                    label: "Niskie piętra (1-4)"
                },
                {
                    id: `floor_choices_${FloorChoice.HIGH_LEVELS.toString()}`,
                    value: FloorChoice.HIGH_LEVELS.toString(),
                    label: "Wysokie piętra (5+)"
                },
                {
                    id: `floor_choices_${FloorChoice.LAST_LEVEL.toString()}`,
                    value: FloorChoice.LAST_LEVEL.toString(),
                    label: "Ostatnie piętro"
                },
                {
                    id: `floor_choices_${FloorChoice.LAST_LEVEL_WITH_TERRACE.toString()}`,
                    value: FloorChoice.LAST_LEVEL_WITH_TERRACE.toString(),
                    label: "Ostatnie piętro z tarasem"
                }
            ]
        }
    ]
};
import {FloorChoice} from "../../../real_estate/types/FloorChoice";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const floorChoices: ISearchFilterSlot<"floor_choices", string[]> = {
    id: "floor_choices",
    label: "Piętro",
    filters: [
        {
            id: "floor_choices",
            type: SearchFilterTypes.MULTI_CHECKBOX,
            filterOptions: [
                {
                    id: `floor_choices_${FloorChoice.GROUND.toString()}`,
                    value: FloorChoice.GROUND.toString(),
                    label: "Parter"
                },
                {
                    id: `floor_choices_${FloorChoice.GROUND_WITH_GARDEN.toString()}`,
                    value: FloorChoice.GROUND_WITH_GARDEN.toString(),
                    label: "Parter z ogródkiem"
                },
                {
                    id: `floor_choices_${FloorChoice.LOW_LEVELS.toString()}`,
                    value: FloorChoice.LOW_LEVELS.toString(),
                    label: "Niskie piętra (1-4)"
                },
                {
                    id: `floor_choices_${FloorChoice.HIGH_LEVELS.toString()}`,
                    value: FloorChoice.HIGH_LEVELS.toString(),
                    label: "Wysokie piętra (5+)"
                },
                {
                    id: `floor_choices_${FloorChoice.LAST_LEVEL.toString()}`,
                    value: FloorChoice.LAST_LEVEL.toString(),
                    label: "Ostatnie piętro"
                },
                {
                    id: `floor_choices_${FloorChoice.LAST_LEVEL_WITH_TERRACE.toString()}`,
                    value: FloorChoice.LAST_LEVEL_WITH_TERRACE.toString(),
                    label: "Ostatnie piętro z tarasem"
                }
            ]
        }
    ]
};
